module.exports = __webpack_public_path__ + "static/media/person-1.c989fa41.png";